export const LOANS = 'md_loans_GLOBAL';